import React, { createContext, useContext, useState, useEffect } from "react";

const LocalStorageContext = createContext();

export const useLocalStorage = () => useContext(LocalStorageContext);

export const LocalStorageProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const getLocalStorageData = () => {
    const storedData = localStorage.getItem("access_token");
    setLoading(false);
    return storedData ? storedData : null;
  };

  const [localStorageData, setLocalStorageData] = useState(getLocalStorageData);

  useEffect(() => {
    if (localStorageData) {
      setLoading(false);
      localStorage.setItem("access_token", localStorageData);
    }
  }, [localStorageData]);

  const updateLocalStorageData = (newData) => {
    if (typeof newData !== "object" || Array.isArray(newData)) {
      return;
    }
    setLocalStorageData((prevData) => ({ ...prevData, ...newData }));
  };

  const clearLocalStorageData = () => {
    setLocalStorageData(null);
    localStorage.clear();
  };

  return (
    <LocalStorageContext.Provider
      value={{
        data: localStorageData,
        loading,
        updateLocalStorageData,
        clearLocalStorageData,
      }}
    >
      {children}
    </LocalStorageContext.Provider>
  );
};
